import React from 'react'
import Isologo from './../Logo/Isologo'
import Typography from '../Typography'
import { TypographyTypes } from '../../constants'
import styled from 'styled-components'
import { getCSSVariable } from '../../constants/cssRules'

const StyledLoading = styled.div`
    display: inline-block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);

    & .rds-isologo {
        display: inline-block;
        margin: unset;
    }

    & .rds-isologo:after {
        content: '';
        width: ${getCSSVariable('loadingShadowSize')};
        height: ${getCSSVariable('loadingShadowSize')};
        opacity: 0.2;
        background-color: inherit;
        background-image: inherit;
        border-radius: inherit;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
    }
`

const StyledTaggedLoading = styled.div`
    display: inline-flex;

    & .rds-loading {
        position: initial;
        width: auto;
        height: auto;
        margin: 0 5px 0 0;
        transform: unset;
        display: inline-flex;
    }

    & .rds-isologo {
        margin: inherit;
    }
`

const Loading = ({ tag, className = '' }) => {
    const getAnimation = () => (
        <StyledLoading className='rds-loading'>
            <Isologo animated big />
        </StyledLoading>
    )
    if (tag) {
        return (
            <StyledTaggedLoading
                className={`rds-flexbox align-center justify-center ${className}`}
            >
                {getAnimation()}
                <Typography className='rds-m_left__sm' type={TypographyTypes.P}>
                    <b>{tag}</b>
                </Typography>
            </StyledTaggedLoading>
        )
    }
    return getAnimation()
}

export default Loading
